import React, { Component, PropTypes } from 'react';
import Money from 'common/components/money';
import RequestPaymentModal from 'account/containers/payout/request_payment_modal';

/**
 * Request payment CTA.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class RequestPayment extends Component {
  constructor(props) {
    super(props);

    this.state = { requesting: false };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({ requesting: !this.state.requesting });
  }

  render() {
    const { balance } = this.props;
    const { requesting } = this.state;

    return (
      <div>
        <div className="callout secondary request-payment">
          <h5>Balance</h5>
          <h1><Money value={balance} /></h1>
          <button className="btn btn-primary" onClick={this.toggleModal} disabled={!balance}>
            Request Payment
          </button>
        </div>
        { requesting && <RequestPaymentModal onClose={this.toggleModal}/> }
      </div>);
  }
};

/**
 * PropTypes.
 *
 * @property {number} balance - account balance
 */
RequestPayment.propTypes = {
  balance: PropTypes.number,
};



// WEBPACK FOOTER //
// ./account/components/payout/request_payment.jsx